import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { unsubscribeToEmail } from '../services/unsubscribeService';

const UnsubscribeComponent: React.FC = () => {
    const location = useLocation();
    const [email, setEmail] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState<string | null>(null);

    // Parse email from query string ?email=...
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailParam = params.get('email');
        setEmail(emailParam);
    }, [location.search]);

    const handleUnsubscribe = async () => {
        if (!email) return;
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const success = await unsubscribeToEmail(email);
            setSuccess(success);

            if (!success) {
                setError('Failed to unsubscribe. Please try again.');
            }
        } catch {
            setError('Failed to unsubscribe. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!email) {
            return <div style={{width: '100%', minHeight: '400px', alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
            <div className='card' style={{maxWidth: '800px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'row'}}>
                <h3>No email provided in the URL.</h3></div></div>;
    }

    if (success) {
        return <div style={{width: '100%', minHeight: '400px', alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
            <div className='card' style={{maxWidth: '800px', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'row'}}>
                <h3>You have been unsubscribed successfully.</h3></div></div>;
    }

    return (
        <div className='card' style={{ maxWidth: 600, margin: 'auto', padding: '2rem', textAlign: 'center' }}>
            <h1>Unsubscribe from All Future Emails</h1>
            <p>Email: <strong>{email}</strong></p>
            <button onClick={handleUnsubscribe} disabled={loading}>
                {loading ? 'Unsubscribing...' : 'Unsubscribe'}
            </button>
            {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
        </div>
    );
};

export default UnsubscribeComponent;
